import { Injectable } from '@angular/core';
import { State, Action, StateContext, Selector } from '@ngxs/store';
import { PreScreeningAction } from './pre-screening.actions';
import { PreScreening } from './pre-screening.model';

export class PreScreeningStateModel {
  public preScreening!: PreScreening;
}

const defaults: PreScreeningStateModel = {
  preScreening: {
    completedPostgraduateTraining: 'No',
    activePractice: 'No',
    completedClinicalPractice: 'No',
    practiceHours: '',
    virtualBasedCareHours: ''
  }
};

@State<PreScreeningStateModel>({
  name: 'preScreeningState',
  defaults
})

@Injectable()
export class PreScreeningState {
  @Action(PreScreeningAction)
  add({ getState, setState }: StateContext<PreScreeningStateModel>, payload: PreScreeningAction) {
    const state = getState();
    setState({ preScreening: { ...state.preScreening, ...payload } });
  }

  @Selector()
  static getPreScreening(state: PreScreeningStateModel) {
    return state.preScreening;
  }

  @Action(PreScreeningAction)
  save({ getState, setState }: StateContext<PreScreeningStateModel>, payload: PreScreeningAction) {
    const state = getState();
    setState({ preScreening: { ...state.preScreening, ...payload } });
  }
}
